export const toStripeAmount = (amount:any) => {
  return Math.floor(amount * 100);
};

export const fromStripeAmount = (amount:any) => {
  return (amount / 100).toFixed(2);
};
